import { Button, Modal } from '@dev-spendesk/grapes';
import { useHistory } from 'react-router-dom';

import { useTranslation } from 'common/hooks/useTranslation';
import { routeFor, routes } from 'src/core/constants/routes';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

type Props = {
  isOpen: boolean;
};

export const SuccessModal = ({ isOpen }: Props) => {
  const history = useHistory();

  const { t } = useTranslation('global');

  const companyId = useCompanyId();

  const goToHub = () => {
    const setupHubPath = routeFor(routes.SETUP_HUB.path, {
      company: companyId,
    });
    history.push(setupHubPath);
  };

  return (
    <Modal
      isOpen={isOpen}
      iconName="circle-check"
      iconVariant="success"
      title={t('setupHub.exportGeneralSettings.successModal.title')}
      onClose={goToHub}
      actions={[
        <Button
          key="switch"
          variant="primaryBrand"
          text={t('misc.done')}
          onClick={goToHub}
        />,
      ]}
    >
      <p>{t('setupHub.exportGeneralSettings.successModal.description')}</p>
    </Modal>
  );
};
